module.exports = __webpack_public_path__ + "static/media/logo-white.8ae8a6e2.svg";